import { Injectable } from '@angular/core';
import { LocalStorageService, LoggingService } from '@varsity/services';
import { DateTime } from 'ionic-angular';

@Injectable()
export class TimeService {
    startDateTime: Date;

    constructor(
        protected localStorageService: LocalStorageService,
        protected loggingService: LoggingService
    ) {
        
    }

    getExpirationDateTime(seconds: number): Date {
        var startDateTime = new Date();
        var totalSeconds = startDateTime.getSeconds() + seconds;        
        startDateTime.setSeconds(totalSeconds);

        return startDateTime;

    }

    // Used for rendering the remaining timer under the cart icon
    getTimerString(seconds: number): number {
        let string = 0;
        let today = new Date();
        let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let dateTime = date + ' ' + time;


        return string;
    }
}



// WEBPACK FOOTER //
// ./src/services/helpers/time.service.ts